import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { Paths } from "../../../paths";
import { EntTradeRegistryFilter } from "../../../models/filters/organic/tradeRegistryFilter";
import { EntTradeRegistry } from "../../../models/organic/tradeRegistry";

export const tradeRegistryApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getTradeRegistryListAll: builder.query<ResponseDataGet<EntTradeRegistry>, EntTradeRegistryFilter>({
	  query: (filter) => ({
		url: `${ Paths.organic.tradeRegistry }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getTradeRegistryById: builder.query<ResponseDataTest<EntTradeRegistry>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.tradeRegistry }/${ id }`,
		method: 'GET'
	  })
	}),
	addTradeRegistry: builder.mutation<ResponseDataTest<EntTradeRegistry>, EntTradeRegistry>({
	  query: (body) => ({
		url: `${ Paths.organic.tradeRegistry }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editTradeRegistry: builder.mutation<ResponseDataTest<EntTradeRegistry>, EntTradeRegistry>({
	  query: (body) => ({
		url: `${ Paths.organic.tradeRegistry }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteTradeRegistry: builder.mutation<ResponseDataTest<EntTradeRegistry>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.tradeRegistry }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useGetTradeRegistryListAllQuery,
  useGetTradeRegistryByIdQuery,
  useAddTradeRegistryMutation,
  useEditTradeRegistryMutation,
  useDeleteTradeRegistryMutation,
  useLazyGetTradeRegistryListAllQuery
} = tradeRegistryApi;
